import React, { FC, useEffect, useRef, useState } from 'react'
import { DottedBtn } from 'Stories/DottedBtn/DottedBtn.stories'
import { useTranslation } from 'react-i18next'
import spotifyIcon from 'Shared/img/spotify-icon.png'
import {
  AccessBlock,
  TrackBlock,
  TrackContainer,
  TrackDescription,
  TrackImg,
  TrackText,
  TrackTitle,
} from './styles'
import { TrackSuccessfullyAddedProps } from './TrackSuccessfullyAddedProps'
// eslint-disable-next-line @typescript-eslint/no-var-requires
const ok = require('Shared/gif/ok.gif')

const TrackSuccessfullyAdded: FC<TrackSuccessfullyAddedProps> = ({
  track,
  handleChangeSpotifyTrack,
}) => {
  const [isShowInfo, setIsShowInfo] = useState(true)
  const { t } = useTranslation()

  const timer = useRef(null)

  useEffect(() => {
    // @ts-ignore
    timer.current = setTimeout(() => setIsShowInfo(false), 2000)
    return () => {
      handleChangeSpotifyTrack()
    }
  }, [])

  // @ts-ignore
  useEffect(() => () => clearTimeout(timer.current), [])

  if (isShowInfo && track) {
    return (
      <AccessBlock>
        <img src={ok} alt="ok" style={{ width: '25px' }} />
        <span>{t('createCampaignPage.successfulyAdded')}</span>
      </AccessBlock>
    )
  }

  return (
    <TrackContainer>
      <TrackBlock>
        {track.album.images.length > 0 && track.album.images.length >= 3 ? (
          <TrackImg
            src={track.album.images[2].url}
            alt={track.name}
            width="40"
          />
        ) : (
          <TrackImg src={spotifyIcon} alt={spotifyIcon} width="40" />
        )}
        <TrackText>
          <TrackTitle>{track.name}</TrackTitle>
          <TrackDescription>{track.artists[0].name}</TrackDescription>
        </TrackText>
      </TrackBlock>
      <DottedBtn
        content={t('createCampaignPage.changeSpotifyTrack')}
        onClick={handleChangeSpotifyTrack}
      />
    </TrackContainer>
  )
}

export default TrackSuccessfullyAdded
